import {Injectable} from '@angular/core';
import {AuthenticationService} from "./authentication.service";
import {LoginHelper} from "../helpers";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {DictionaryItem} from "../_models/dictionaryItem";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class DictionaryService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getAll() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/dictionary')
      ;
  }

  isAssigned(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/dictionary/assigned/' + id)
      ;
  }

  get(dictionaries: string[]) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/dictionary/list', dictionaries);
  }

  ensureDefaultTopics() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/dictionary/ensureDefaultTopics', {});
  }

  @Load()
  save(dictionaryItem: DictionaryItem) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/dictionary', dictionaryItem)
      ;
  }

  @Load()
  delete(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/dictionary/' + id + '')
      ;
  }

  @Load()
  import(entity: File, dictionary: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + `/api/dictionary/import/` + dictionary, formData);
  }
  @Load()
  importVendors(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + `/api/dictionary/importVendors`, formData);
  }

  @Load()
  uploadLogo(logo: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(logo.name, logo);

    return this.http
      .post<any>(this.config.api + '/api/dictionary/image', formData);
  }
}
